<template>
  <div id="container"></div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import mockJson from "@/data/mock.json";

var boundsDatas = [];
export default {
  mounted() {
    fetch('./data/bounds.json')
      .then(response => response.json())
      .then(data => {
        boundsDatas = data;

        // console.log(boundsDatas)

        this.initAMap();
      })
      .catch(error => console.error('Error fetching JSON:', error));


  },
  methods: {
    initAMap() {
      AMapLoader.load({
        key: "c3aaff0b1cc2a6a64b90786128fde5b5", // 申请好的Web端开发者Key，首次调用 load 时必填
        //  version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.DistrictLayer', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.DistrictSearch'],
        //   // 高德 sdk 版本，默认为 1.4.4
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            // viewMode: "3D", // 是否为3D地图模式
            zoom: 0.1, // 初始化地图级别
            center: [114.091058, 32.148624], // 初始化地图中心点位置
            mapStyle: "amap://styles/blue",

          });
          this.drawMap();  //画边界
          this.drawBounds1();  //画边界
        })
        .catch((e) => {
          console.log(e);
        });

    },

    async drawMap() {
      var colors = ['#1975d1', '#23cb71', '#0096a6', 'aquamarine', '#376d10', '#5eb6ad', '#5e6db6', '#6f5eb6', '#83dcf9', '#104f37'];
      //如果是市级
      if (localStorage.getItem("unitCode").indexOf('00000000') != -1) {
        // const action = "/web/v3/transactionData?unitCode=" + localStorage.getItem("unitCode");
        // const { data: res } = await this.$http.get(action);
        var resData = mockJson;

        var list = resData.data || [];
        for (var i = 0; i < list.length; i++) {
          // if("no_data"==this.drawBounds(res.data[i].unitCode.substring(0, 6), 'district', colors[i], res.data[i])){
          this.drawBoundsOld(list[i].unitCode.substring(0, 6), 'district', colors[i], list[i]);
          //  }
          await this.sleep(1000);
        }
        this.drawBoundsOld(localStorage.getItem("unitName"), 'city', '');

        for (var i = 0; i < list.length; i++) {
          // if("no_data"==this.drawBounds(list[i].unitCode.substring(0, 6), 'district', colors[i], list[i])){
          this.drawBoundsOld(list[i].unitCode.substring(0, 6), 'district', colors[i], list[i]);
          //  }
          await this.sleep(1000);
        }
        this.drawBoundsOld(localStorage.getItem("unitName"), 'city', '');
      }
      else {
        this.drawBoundsOld(localStorage.getItem("unitCode").substring(0, 6), 'district', '#1975d1',);
      }
      //  console.log(boundsDatas);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    getBoundaries(unitCode) {
      for (var i = 0; i < boundsDatas.length; i++) {
        if (boundsDatas[i].unitCode == unitCode) {
          return boundsDatas[i].boundaries
        }
      }
      return null;
    },
    drawBounds(unitName, type, color, data) {
      var district = null;
      var polygons = [];
      //加载行政区划插件
      if (!district) {
        //实例化DistrictSearch
        var opts = {
          subdistrict: 1,   //获取边界不需要返回下级行政区
          extensions: 'all',  //返回行政区边界坐标组等具体信息
          level: type  //查询行政级别为 市
        };
        district = new AMap.DistrictSearch(opts);
      }
      var that = this;
      //行政区查询
      district.setLevel(type)
      district.search(unitName, function (status, result) {
        console.log(status)
      that.map.remove(polygons)//清除上次结果
      polygons = [];
      // if(status=="no_data"){
      //   return "no_data";
      // }
      // boundsDatas.push({unitCode:unitName,boundaries:result.districtList[0].boundaries});

      var bounds = that.getBoundaries(unitName);
      if (bounds == null) {
        return;
      }
      if (bounds != null) {
        for (var i = 0, l = bounds.length; i < l; i++) {
          //生成行政区划polygon
          var polygon = new AMap.Polygon({
            strokeWeight: 1,
            path: bounds[i],
            fillOpacity: 0.85,
            fillColor: color,
            strokeStyle: 'dashed',
            strokeWeight: 2,
            strokeColor: color,
            strokeDasharray: [10, 2, 10]
          });
          polygons.push(polygon);
        }

        console.log(polygons)
        var marker = new AMap.Marker({
          position: [data.location.split(',')[0], data.location.split(',')[1]],
          map: that.map
        });
        marker.setLabel({
          offset: new AMap.Pixel(20, 20), // 文字偏移量
          content: data.unitName  // 要显示的文字
        });

        var infoWindow = new AMap.InfoWindow({ isCustom: true, offset: new AMap.Pixel(0, -30) });

        marker.content = data.unitName + "： 交易量：" + data.tradeNum + "个 、交易额：" + data.tradeSumMoney + "万元";

        marker.on('click', function (e) {
          infoWindow.setContent(e.target.content);
          infoWindow.open(that.map, e.target.getPosition());
        });
        // marker.emit('click', { target: marker });

      }
      //that.map.setFitView();

      that.map.add(polygons)
      // that.map.setFitView(polygons);//视口自适应
      that.map.setZoom(8.4);
       });
    },
    drawBoundsOld(unitName, type, color, data) {
      var district = null;
      var polygons = [];
      //加载行政区划插件
      if (!district) {
        //实例化DistrictSearch
        var opts = {
          subdistrict: 1,   //获取边界不需要返回下级行政区
          extensions: 'all',  //返回行政区边界坐标组等具体信息
          level: type  //查询行政级别为 市
        };
        district = new AMap.DistrictSearch(opts);
      }
      var that = this;
      //行政区查询
      district.setLevel(type)
      district.search(unitName, function (status, result) {
        //console.log(status)
        that.map.remove(polygons)//清除上次结果
        polygons = [];
        // if(status=="no_data"){
        //   return "no_data";
        // }
        console.log(result.districtList[0].boundaries);

        var bounds = result.districtList[0].boundaries;
        if (bounds) {
          for (var i = 0, l = bounds.length; i < l; i++) {
            //生成行政区划polygon
            var polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.85,
              fillColor: color,
              strokeStyle: 'dashed',
              strokeWeight: 2,
              strokeColor: color,
              strokeDasharray: [10, 2, 10]
            });
            polygons.push(polygon);
          }


          var marker = new AMap.Marker({
            position: [data.location.split(',')[0], data.location.split(',')[1]],
            map: that.map
          });
                      // 设置标记上显示的文字
            marker.setLabel({ 
              offset: new AMap.Pixel(20, 20), // 文字偏移量
              content: data.unitName  // 要显示的文字
            });

          var infoWindow = new AMap.InfoWindow({ isCustom: true, offset: new AMap.Pixel(0, -30) });

          marker.content = data.unitName + "： 交易量：" + data.tradeNum + "个 、交易额：" + data.tradeSumMoney + "万元";
    
          marker.on('click', function (e) {
            infoWindow.setContent(e.target.content);
            infoWindow.open(that.map, e.target.getPosition());
          });
          // marker.emit('click', { target: marker });

        }
        //that.map.setFitView();

        that.map.add(polygons)
       // that.map.setFitView(polygons);//视口自适应
        that.map.setZoom(8.4);
      });
    },
    drawBounds1() {
      var district = null;
      var polygons = [];
      //加载行政区划插件
      if (!district) {
        //实例化DistrictSearch
        var opts = {
          subdistrict: 1,   //获取边界不需要返回下级行政区
          extensions: 'all',  //返回行政区边界坐标组等具体信息
          level: 'district'  //查询行政级别为 市
        };
        district = new AMap.DistrictSearch(opts);
      }

      var that = this;
      //行政区查询
      district.setLevel('city')
      district.search('信阳市', function (status, result) {
        console.log(status)
        that.map.remove(polygons)//清除上次结果
        polygons = [];
        var bounds = result.districtList[0].boundaries;
        if (bounds) {
          for (var i = 0, l = bounds.length; i < l; i++) {
            //生成行政区划polygon
            var polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.75,
              fillColor: '#80d8ff',
              strokeStyle: 'dashed',
              strokeWeight: 2,
              strokeColor: '#0091ea',
              strokeDasharray: [10, 2, 10]
            });
            polygons.push(polygon);
          }
        }
        that.map.add(polygons)
        that.map.setFitView(polygons);//视口自适应
        that.map.setZoom(8.4);
      });
    },


  },
};
</script>
<style lang="scss">
.amap-marker-label {
  border: none !important;
  background-color: #ffffff00;
  color: #0d2b37;
  font-weight: 800;
  margin-left: -27px;
  margin-top: 5px;

}

#container {
  width: 100%;
  height: 800px;
}

.amap-info-contentContainer.bottom-left,
.amap-info-contentContainer.bottom-center,
.amap-info-contentContainer.bottom-right {
  background-color: #0a2732f5;
  padding: 5px;
  font-size: 12px;
  font-weight: 800;

}
</style>
